import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  themeColumnsMinimized,
} from "../../../utils/gridHelper";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useStore } from "../../../hooks/store";
import IconButton from "@mui/material/IconButton";
import {
  getTheme,
  getThemeToQuestion,
  postThemeToQuestion,
} from "../../../utils/API/themeMethods";

export default function ThemeSmallGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");

  const fetchThemeData = () => {
    getTheme().then(({ data }) => {
      setGridData(data);
    });
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchThemeData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data &&
      postThemeToQuestion(store.form.dataToUpdate.id, e.data.id).then(
        ({ data, status }) => {
          if (status === 200) {
            store.setAlert(data, "success");
            getThemeToQuestion(store.form.dataToUpdate.id).then(({ data }) => {
              store.form.dataToUpdate.themes = data;
              store.closeChildModal();
            });

            return;
          }
          store.setAlert(data, "error");
          return;
        }
      );
  };

  return (
    <div style={{ width: "300px", height: "300px", paddingTop: "20px" }}>
      <OutlinedInput
        sx={{ marginBottom: "10px" }}
        id={"quickFilter"}
        name={"quickFilter"}
        size="small"
        fullWidth
        onChange={(e) => setQuickFilterText(e.target.value)}
        value={quickFilterText}
        placeholder="Поиск темы"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              sx={{ p: "2px" }}
              onClick={() => setQuickFilterText("")}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        }
      />

      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...themeColumnsMinimized]}
      />
    </div>
  );
}
